import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_URL_BACK,
  headers: { "Access-Control-Allow-Origin": "*" },
});

export default api;
